<ng-container *ngFor="let key of agentCampaignsKeys">
  <div
    *ngIf="!!log && hasLog(key, log)"
    [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML: agentCampaignsLookup : null"
  ></div>
</ng-container>
